import { createStore, createEvent } from 'effector'
import { IPictureModalProps } from "components/PictureModal/PictureModal"

const show = createEvent<IPictureModalProps>()
const hide = createEvent<IPictureModalProps>()
const clear = createEvent()

const list = createStore<IPictureModalProps[]>([])

list.on(show, (state: IPictureModalProps[], pictureModal: IPictureModalProps) => {
    return [
        ...state,
        pictureModal
    ]
})

list.on(hide, (state: IPictureModalProps[], pictureModal: IPictureModalProps) => {
    return state
        .filter(pm => pm !== pictureModal)
})

list.on(clear, () => [])

export default {
    show,
    hide,
    clear,
    list
}
